import { cn } from '@/lib/utils'

type HomeMode = 'chat' | 'study'

interface HomeModeToggleProps {
  value: HomeMode
  onChange: (value: HomeMode) => void
  className?: string
}

export function HomeModeToggle({ value, onChange, className }: HomeModeToggleProps) {
  return (
    <div
      className={cn(
        'inline-flex h-[35px] shrink-0 items-center rounded-[4px] px-[4px] py-[4px] shadow-soft',
        'bg-[color-mix(in_srgb,hsl(var(--primary-dark))_12%,white)]',
        className,
      )}
    >
      {(['chat', 'study'] as const).map((option) => {
        const active = option === value

        return (
          <button
            key={option}
            type="button"
            onClick={() => onChange(option)}
            className={cn(
              'flex items-center justify-center whitespace-nowrap px-[8px] py-[4px] text-[16px] font-medium leading-[1.2] tracking-[-0.32px] transition-colors duration-150',
              active
                ? 'rounded-[2px] bg-white text-[hsl(var(--primary-dark))]'
                : 'text-[color-mix(in_srgb,hsl(var(--primary-dark))_82%,white)] hover:text-[hsl(var(--primary-dark))]',
            )}
          >
            {option === 'chat' ? 'Chat' : 'Study'}
          </button>
        )
      })}
    </div>
  )
}
